import React, { useEffect } from 'react'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import {
  CloseButton,
  ModalFlex,
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import { ServicesModalWrapper } from '../../../components/Calendar/ReservationModal'
import Button from '../../../components/Template/Button'
import { SquareCheckbox } from '../../../components/FormBuilder'
import CursorPointer from '../../../components/Template/CursorPointer/CursorPointer'
import { driver, names } from '../../../database/localStorage'
import { is } from '../../../components/MediaQuery'
import { FormNames } from '../../Form/CreateReservation'
import useSize from '../../../hooks/useSize'
import { useSelector } from 'react-redux'
import { getUpdateModalReservationId } from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { Mixpanel } from '../../../utils/Mixpanel'
import { isDirty } from 'redux-form'
import { getUserId } from '../../../reducers/userAccount/selectors/userAccount'

function CloseModal({
  close,
  open,
  t,
  type,
  closeReservationModal,
}: ICloseModalProps & ICloseModalDispatch & WithTranslation) {
  const [value, setValue] = React.useState(false)
  const size = useSize()
  const isDesktop = is.desktop()
  const eventId = useSelector(getUpdateModalReservationId)
  const dirty = useSelector(isDirty(FormNames.Update))
  const userId = useSelector(getUserId)

  useEffect(() => {
    if (open) {
      Mixpanel.track('Reservation Form Exit Screen', {
        'Reservation ID': Number(eventId),
      })
    }
  }, [open, eventId])

  function warningMessage() {
    return t('exit_reservation_confirmation')
      .split('\\n')
      .map((mes, index) => <span key={index}>{mes}</span>)
  }

  function onClose() {
    if (value) {
      driver.setItem(names.UserAccountStorage.DontShowAgainCloseModal, '1')
    }
    Mixpanel.track('Reservation Form Exit Screen Confirmed', {
      'Reservation ID': Number(eventId),
      'Reservation Form Exit Action': 'Cancel',
      "Reservation Form Exit Don't Show Again?":
        driver.getItem(names.UserAccountStorage.DontShowAgainCloseModal, '') ===
        '1',
    })
    close()
  }

  function onchange() {
    setValue(!value)
  }

  function exit() {
    Mixpanel.track('Reservation Form Exit Screen Confirmed', {
      'Reservation ID': Number(eventId),
      'Reservation Form Exit Action': 'Exit',
      "Reservation Form Exit Don't Show Again?":
        driver.getItem(names.UserAccountStorage.DontShowAgainCloseModal, '') ===
        '1',
    })
    onClose()
    if (dirty) {
      Mixpanel.track('Reservation Form Abandoned', {
        'Reservation ID': Number(eventId),
        'Tabs Form View?': true,
      })
      Mixpanel.people.increment(userId, 'Reservation Form Abandonments', 1)
    }
    closeReservationModal(type)
  }

  return (
    <ModalFlex
      style={{ marginBottom: isDesktop ? '30vh' : 0 }}
      open={open}
      onClose={onClose}
    >
      <ServicesModalWrapper>
        <ModalHeader
          style={{ padding: `${size}em ${0.4 * size}em 0px ${1.3 * size}em` }}
        >
          <Flex style={{ width: '100%' }} justifyStart={true}>
            <ModalHeaderLabel size={size}>
              <Trans i18nKey={'BBO_949_warning'}>Ostrzeżenie</Trans>
            </ModalHeaderLabel>
          </Flex>
          <Flex style={{ width: '100% ' }} justifyEnd={true} alignCenter={true}>
            <CloseButton size={size} onClose={onClose} />
          </Flex>
        </ModalHeader>
        <Flex
          column={true}
          style={{
            fontSize: `${16 * size}px`,
            padding: `${10 * size}px ${1.3 * size}em ${10 * size}px ${1.3 *
              size}em`,
          }}
        >
          {warningMessage()}

          <CursorPointer style={{ marginTop: `${1.5 * size}em` }}>
            <SquareCheckbox.Field
              size={size}
              fireEventOnClick={true}
              value={value}
              onChange={onchange}
              label={t('dont_show_again')}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />
          </CursorPointer>
        </Flex>
        <Flex
          row={true}
          style={{
            marginBottom: `${20 * size}px`,
            marginLeft: `${1.3 * size}em`,
            marginRight: `${1.3 * size}em`,
            marginTop: `${15 * size}px`,
          }}
        >
          <Button size={size} style={{ width: '100%' }} onClick={onClose}>
            <Trans i18nKey={'cancel'} />
          </Button>
          <Button
            size={size}
            style={{ width: '100%' }}
            onClick={exit}
            primary={true}
          >
            <Trans i18nKey={'exit'} />
          </Button>
        </Flex>
      </ServicesModalWrapper>
    </ModalFlex>
  )
}

export default withTranslation()(CloseModal)

export interface ICloseModalProps {
  open?: boolean
  type?: FormNames
}

export interface ICloseModalDispatch {
  close?: () => void
  closeReservationModal?: (form: FormNames) => void
}
